export const sendDecibelData = ({ digitalData = { page_data: {} } }) => {
  window.decibelInsight &&
    window.decibelInsight('trackPageView', digitalData.page_data.page_path);
};
